export const WIDGET_STATE = {
    WRITE_TO_US_FORM: 'form',
    CHAT: 'chat',
    KNOWLEDGE_BASE: 'knowledge',
};
export const DEFAULT_BACKGROUND_COLOR = '#12a489';
export const DEFAULT_TEXT_COLOR = '#262732';
export const MAX_FILES_SIZE_MEGABYTES = 15;
export const MAX_FILES_SIZE_BYTES = MAX_FILES_SIZE_MEGABYTES * 1024 * 1024;
export const RECAPTCHA_KEY_ID = '6LeibikeAAAAAO8H8EMAVlAK5dwnyETr9sJ93btA';
export const RECAPTCHA_URL = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_KEY_ID}`;
